import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { ITextVariablesClient, TextVariablesClient } from "app/ApiClient";
import { IState } from "slices";
import { LoadingState } from "types";
import { initialOpenEndVariablesState } from "./openEndVariablesState";

const textVariablesClient: ITextVariablesClient = new TextVariablesClient(process.env.REACT_APP_API_URL);

export const getOpenEndVariables = createAsyncThunk(
  "textVariables/getOpenEndVariables",
  async ({ projectId, versionId }: { projectId: number; versionId: string }, { rejectWithValue }) => {
    try {
      const result = await textVariablesClient.getOpenEndVariables(projectId, versionId);
      return result;
    } catch (error) {
      return rejectWithValue(error);
    }
  },
);

const openEndVariablesSlice = createSlice({
  name: "openEndVariables",
  initialState: initialOpenEndVariablesState,
  reducers: {},
  extraReducers: (builder) => {
    // getOpenEndVariables
    builder.addCase(getOpenEndVariables.pending, (state) => {
      state.openEndVariables = [];
      state.loading = LoadingState.pending;
    });
    builder.addCase(getOpenEndVariables.fulfilled, (state, { payload }) => {
      state.openEndVariables = payload ?? [];
      state.loading = LoadingState.succeed;
    });
    builder.addCase(getOpenEndVariables.rejected, (state) => {
      state.openEndVariables = [];
      state.loading = LoadingState.failed;
    });
  },
});
export const openEndVariablesSelector = (state: IState) => state.brands;
export default openEndVariablesSlice.reducer;
